
import { defineComponent, PropType } from "vue";

export default defineComponent({
  data: () => ({
    canvasRotation: Math.floor(Math.random() * 360),
    dice1Rotation: Math.floor(Math.random() * 360),
    dice2Rotation: Math.floor(Math.random() * 360),
  }),
  props: {
    dice: { type: Array as PropType<number[]>, required: true },
  },
});
